import React, { useEffect, useRef, useState } from 'react';
import { ModalWraper } from '../UI/styledConstants';
import IconClose from '../../assets/images/IconClose';
import logoBlack from '../../assets/images/logoBlack.svg';

import backgroundImg from '../../assets/images/bg-img.png';
import { clickOutside, downloadDivAsImage, getCurrentDate, numberToWords, overLayers } from '../../utils/common';
import successImg from '../../assets/images/successimg.png';
import { isEmpty } from 'lodash';
import bbpsLogo from '../../assets/images/bbpsLogo2.png';
import { useNavigate } from 'react-router-dom';
const TransactionReceipt = ({ closePop, transactionType = 'g', bankDataResp, page = 'transaction' }) => {
	const [customCss, setCustonCss] = useState({});
	const [zoom, setZoom] = useState('zoom-0');
	const navigate = useNavigate();

	const heightCss = {
		height: '150px',
	};

	const handleDownloadClick = (title) => {
		setCustonCss({ height: 'auto' });
		setTimeout(() => {
			const divElement = document.getElementById('model');
			downloadDivAsImage(divElement, title, setCustonCss, heightCss);
		});
	};

	const handleCopy = (e, value) => {
		let target = e.target;

		navigator.clipboard
			.writeText(value)
			.then(() => {
				target.classList.add('active');

				(function (param) {
					setTimeout(() => {
						param.classList.remove('active');
					}, 1500);
				})(target);
			})
			.catch((err) => {
				console.error('Failed to copy text:', err);
			});
	};

	const regExpDebit = /^D/i;
	const bbpsService = ['BBPS', 'PREPAID_RECHARGE', 'WATER', 'ELECTRICITY'];

	useEffect(() => {
		setZoom('zoom-1');
	}, []);

	const close = () => {
		setZoom('zoom-0');
		setTimeout(() => {
			closePop();
		}, 300);
	};
	const boxRef = useRef(null);
	useEffect(() => {
		overLayers(true);
		clickOutside(true, boxRef, close);

		return () => {
			overLayers(false);
			clickOutside(false, boxRef, close);
		};
	}, []);
	return (
		<ModalWraper url={backgroundImg}>
			<div className={`modal modal-success modal-body-aeps ${zoom}`} id="model" ref={boxRef}>
				<div className="flex modal-header justify-between">
					<div className="logo self-center">
						<img src={logoBlack} alt={'logo'} />
						<div>
							<p>Invoicing and payments</p>
							<p>powered by Pay2Mobile</p>
						</div>
					</div>
				</div>
				<div className="modal-close" onClick={close}>
					<IconClose />
				</div>

				{page === 'transaction' && (
					<>
						{transactionType !== 'AEPS' && (
							<div className="text-center modal-title">
								<h2 className="transactionMsg" style={{ fontSize: '18px' }}>
									Amount
								</h2>
								<h3 className="amount">₹ {bankDataResp?.amount}</h3>
								<p className="amount-text fs-sm-12">{numberToWords(bankDataResp?.amount)}</p>
							</div>
						)}

						{transactionType === 'AEPS' && bankDataResp?.route === 'CASH_WITHDRAWAL' && (
							<div className="text-center modal-title">
								{/* <h2 className="transactionMsg" style={{fontSize:"18px"}}>Transaction Successful!</h2> */}
								<h3 className="amount">₹ {bankDataResp?.amount}</h3>
								<p className="amount-text fs-sm-12">{numberToWords(bankDataResp?.amount)}</p>
							</div>
						)}

						<div className="modal-body ">
							<div className="txn-daital">
								<div className="flex justify-between txn-daital-h">
									<div>Send To</div>
									<div></div>
								</div>
								{!isEmpty(bankDataResp?.status) && (
									<div className="flex justify-between txn-desc">
										<div className="txn-desc-right fs-sm-12">
											<div>
												<span className="fs-sm-12">Status</span>
											</div>
										</div>
										<div className="txn-desc-left fs-sm-12">
											<div>
												<span>
													<div className="detail-desc success fs-sm-12">
														{bankDataResp?.status?.toLowerCase() === 'success' ? (
															<>
																<img src={successImg} alt={'success'} />
																{bankDataResp?.status}
															</>
														) : (
															<span style={{ color: 'red' }}> {bankDataResp?.status}</span>
														)}
													</div>
												</span>
											</div>
										</div>
									</div>
								)}
								{!isEmpty(bankDataResp?.rechargedNumber) && (
									<div className="flex justify-between txn-desc">
										<div className="txn-desc-right fs-sm-12">
											<div>
												<span>Recharged Number</span>
											</div>
										</div>
										<div className="txn-desc-left fs-sm-12">
											<div>
												<span>{bankDataResp?.rechargedNumber}</span>
											</div>
										</div>
									</div>
								)}

								{!isEmpty(bankDataResp?.userFullName) && (
									<div className="flex justify-between txn-desc">
										<div className="txn-desc-right fs-sm-12">
											<div>
												<span>Reatiler Name</span>
											</div>
										</div>
										<div className="txn-desc-left fs-sm-12">
											<div>
												<span>{bankDataResp?.userFullName}</span>
											</div>
										</div>
									</div>
								)}
								{!isEmpty(bankDataResp?.serviceType) && (
									<div className="flex justify-between txn-desc">
										<div className="txn-desc-right fs-sm-12">
											<div>
												<span>Service Type</span>
											</div>
										</div>
										<div className="txn-desc-left fs-sm-12">
											<div>
												<span>{bankDataResp?.serviceType}</span>
											</div>
										</div>
									</div>
								)}

								{!isEmpty(bankDataResp?.accountHolderName) && (
									<div className="flex justify-between txn-desc">
										<div className="txn-desc-right fs-sm-12">
											<div>
												<span>Account Holder Name</span>
											</div>
										</div>
										<div className="txn-desc-left fs-sm-12">
											<div>
												<span>{bankDataResp?.accountHolderName}</span>
											</div>
										</div>
									</div>
								)}
								{!isEmpty(bankDataResp?.accountIfscCode) && (
									<div className="flex justify-between txn-desc">
										<div className="txn-desc-right fs-sm-12">
											<div>
												<span>IFSC Code</span>
											</div>
										</div>
										<div className="txn-desc-left fs-sm-12">
											<div>
												<span>{bankDataResp?.accountIfscCode}</span>
											</div>
										</div>
									</div>
								)}
								{(!isEmpty(bankDataResp?.accountNumber) && transactionType === 'SEND_MONEY') ||
									(!isEmpty(bankDataResp?.accountNumber) && transactionType === 'BBPS' && (
										<div className="flex justify-between txn-desc">
											<div className="txn-desc-right fs-sm-12">
												<div>
													<span>Account Number</span>
												</div>
											</div>
											<div className="txn-desc-left fs-sm-12">
												<div>
													<span>{bankDataResp?.accountNumber}</span>
												</div>
											</div>
										</div>
									))}
								{!isEmpty(bankDataResp?.customerMobile) && (
									<div className="flex justify-between txn-desc">
										<div className="txn-desc-right fs-sm-12">
											<div>
												<span>Customer Mobile</span>
											</div>
										</div>
										<div className="txn-desc-left fs-sm-12">
											<div>
												<span>{bankDataResp?.customerMobile}</span>
											</div>
										</div>
									</div>
								)}
								{!isEmpty(bankDataResp?.aadhaar) && (
									<div className="flex justify-between txn-desc">
										<div className="txn-desc-right fs-sm-12">
											<div>
												<span>Customer Aadhaar</span>
											</div>
										</div>
										<div className="txn-desc-left fs-sm-12">
											<div>
												<span>{bankDataResp?.aadhaar}</span>
											</div>
										</div>
									</div>
								)}
								{!isEmpty(bankDataResp?.bankAccountBalance) && (
									<div className="flex justify-between txn-desc">
										<div className="txn-desc-right fs-sm-12">
											<div>
												<span>Customer Balance</span>
											</div>
										</div>
										<div className="txn-desc-left fs-sm-12">
											<div>
												<span>{bankDataResp?.bankAccountBalance}</span>
											</div>
										</div>
									</div>
								)}
								{!isEmpty(bankDataResp?.route) && (
									<div className="flex justify-between txn-desc">
										<div className="txn-desc-right fs-sm-12">
											<div>
												<span>Route</span>
											</div>
										</div>
										<div className="txn-desc-left fs-sm-12">
											<div>
												<span>{bankDataResp?.route}</span>
											</div>
										</div>
									</div>
								)}

								{!isEmpty(bankDataResp?.transactionId) && (
									<div className="flex justify-between txn-desc">
										<div className="txn-desc-right fs-sm-12">
											<div>
												<span>Transaction ID</span>
											</div>
										</div>
										<div className="txn-desc-left fs-sm-12">
											<div>
												<span>{bankDataResp?.transactionId}</span>
											</div>
										</div>
									</div>
								)}
								{!isEmpty(bankDataResp?.refTransactionId) && (
									<div className="flex justify-between txn-desc">
										<div className="txn-desc-right fs-sm-12">
											<div>
												<span>Reference No</span>
											</div>
										</div>
										<div className="txn-desc-left fs-sm-12">
											<div>
												<span>{bankDataResp?.refTransactionId}</span>
											</div>
										</div>
									</div>
								)}
								{!isEmpty(bankDataResp?.transactionDate) && (
									<div className="flex justify-between txn-desc">
										<div className="txn-desc-right fs-sm-12">
											<div>
												<span>Date And Time</span>
											</div>
										</div>
										<div className="txn-desc-left fs-sm-12">
											<div>
												<span> {getCurrentDate('', bankDataResp?.transactionDate, true)}</span>
											</div>
										</div>
									</div>
								)}
							</div>
						</div>
					</>
				)}

				{page === 'addmoney' && (
					<>
						<div className="text-center modal-title">
							<h2 className="transactionMsg" style={{ fontSize: '18px' }}>
								{' '}
								{bankDataResp?.txnStatus?.toLowerCase() === 'success'
									? 'Transaction Successful!'
									: bankDataResp?.txnStatus?.toLowerCase() === 'pending'
									? 'Transaction pending'
									: bankDataResp?.txnStatus?.toLowerCase() === 'refund'
									? 'Refund'
									: 'Transaction failed'}
							</h2>
							{/* <h3 className="amount">₹ {bankDataResp?.transactionAmout}</h3>
							<p className="amount-text fs-sm-12">{numberToWords(bankDataResp?.transactionAmout)}</p> */}
							<h3 className="amount">₹ {bankDataResp?.finalTxnAmount?.toFixed(2) || '0.00'}</h3>

							<p className="amount-text fs-sm-12">{numberToWords(bankDataResp?.finalTxnAmount)}</p>
						</div>

						<div className="modal-body ">
							<div className="txn-daital">
								<div className="flex justify-between txn-daital-h">
									<div>Send To</div>
									<div></div>
								</div>
								{!isEmpty(bankDataResp?.txnStatus) && (
									<div className="flex justify-between txn-desc">
										<div className="txn-desc-right fs-sm-12">
											<div>
												<span className="fs-sm-12">Status</span>
											</div>
										</div>
										<div className="txn-desc-left fs-sm-12">
											<div>
												<span>
													<div className="detail-desc success fs-sm-12">
														{bankDataResp?.txnStatus?.toLowerCase() === 'success' ? (
															<>
																<img src={successImg} alt={'success'} />
																{bankDataResp?.txnStatus}
															</>
														) : (
															<span style={{ color: 'red' }}> {bankDataResp?.txnStatus}</span>
														)}
													</div>
												</span>
											</div>
										</div>
									</div>
								)}

								{!isEmpty(bankDataResp?.userFullName) && (
									<div className="flex justify-between txn-desc">
										<div className="txn-desc-right fs-sm-12">
											<div>
												<span>Reatiler Name</span>
											</div>
										</div>
										<div className="txn-desc-left fs-sm-12">
											<div>
												<span>{bankDataResp?.userFullName}</span>
											</div>
										</div>
									</div>
								)}
								{!isEmpty(bankDataResp?.serviceType) && (
									<div className="flex justify-between txn-desc">
										<div className="txn-desc-right fs-sm-12">
											<div>
												<span>Service Type</span>
											</div>
										</div>
										<div className="txn-desc-left fs-sm-12">
											<div>
												<span>{bankDataResp?.serviceType}</span>
											</div>
										</div>
									</div>
								)}

								{!isEmpty(bankDataResp?.transactionType) && (
									<div className="flex justify-between txn-desc">
										<div className="txn-desc-right fs-sm-12">
											<div>
												<span>Transaction Type</span>
											</div>
										</div>
										<div className="txn-desc-left fs-sm-12">
											<div>
												<span>{bankDataResp?.transactionType}</span>
											</div>
										</div>
									</div>
								)}

								{!isEmpty(bankDataResp?.transactionId) && (
									<div className="flex justify-between txn-desc">
										<div className="txn-desc-right fs-sm-12">
											<div>
												<span>Transaction ID</span>
											</div>
										</div>
										<div className="txn-desc-left fs-sm-12">
											<div>
												<span>{bankDataResp?.transactionId}</span>
											</div>
										</div>
									</div>
								)}
								{!isEmpty(bankDataResp?.refTransactionId) && (
									<div className="flex justify-between txn-desc">
										<div className="txn-desc-right fs-sm-12">
											<div>
												<span>Reference No</span>
											</div>
										</div>
										<div className="txn-desc-left fs-sm-12">
											<div>
												<span>{bankDataResp?.refTransactionId}</span>
											</div>
										</div>
									</div>
								)}
								{!isEmpty(bankDataResp?.createdDate) && (
									<div className="flex justify-between txn-desc">
										<div className="txn-desc-right fs-sm-12">
											<div>
												<span>Date And Time</span>
											</div>
										</div>
										<div className="txn-desc-left fs-sm-12">
											<div>
												<span> {getCurrentDate('', bankDataResp?.createdDate, true)}</span>
											</div>
										</div>
									</div>
								)}
								{
									<div className="flex justify-between txn-desc">
										<div className="txn-desc-right fs-sm-12">
											<div>
												<span>Opening Amount</span>
											</div>
										</div>
										<div className="txn-desc-left fs-sm-12">
											<div>
												<span>₹ {bankDataResp?.openingAmount?.toFixed(2) || 0}</span>
											</div>
										</div>
									</div>
								}
								<div className="flex justify-between txn-desc">
									<div className="txn-desc-right fs-sm-12">
										<div>
											<span>Transaction Amount</span>
										</div>
									</div>
									<div className="txn-desc-left fs-sm-12">
										<div>
											<span>₹ {bankDataResp?.finalTxnAmount?.toFixed(2) || 0}</span>
										</div>
									</div>
								</div>

								<div className="flex justify-between txn-desc">
									<div className="txn-desc-right fs-sm-12">
										<div>
											<span>Closing Amount</span>
										</div>
									</div>
									<div className="txn-desc-left fs-sm-12">
										<div>
											<span>₹ {bankDataResp?.currentAmount?.toFixed(2) || 0}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</>
				)}

				<div className="buttons center gap-10" style={{ marginTop: '40px' }}>
					<button className="button-solid center gap-6" onClick={() => handleDownloadClick('send money receipt')}>
						<i className="fa-solid fa-download"></i> Download
					</button>
					<button className="button-solid center gap-6" onClick={() => window.print()}>
						<i className="fa-solid fa-print"></i> Print
					</button>
				</div>
			</div>
		</ModalWraper>
	);
};

export default TransactionReceipt;
